import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from 'react-router-dom'

const TransformComponent = ({data}) => {
  return (
    data ? (<Paper
      sx={{
        background:
          "linear-gradient(90.92deg, #000000 0.5%, rgba(102, 102, 102, 0) 36.86%)",
        filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
        position: "relative",
        maxWidth: "100%",
        height: { xs: "300px", sm: "480px" },
        backgroundColor: "#7F0055",
        marginTop: { xs: "2%", sm: "3%" },
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      {/* Background Image */}
      <img
        src="/assets/AdvancedAI/transformBusiness.webp"
        alt="Transform"
        loading="lazy"
        style={{
          position: "absolute",
          top: "0",
          height: "100%",
          width: "auto",
          zIndex: "-1",
          filter: { xs: "brightness(40%)", sm: "none" }, // Dull the image on mobile
        }}
      />
      {/* Overlay for mobile background dullness */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.6)", // Dark overlay to dull the image
          zIndex: "-1",
          display: { xs: "block", sm: "none" }, // Display overlay only on mobile
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: { xs: "10%", sm: "24%" },
          top: { xs: "25%", sm: "30%" },
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
          padding: { xs: "0 10%", sm: "0 5% 0 20%" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: { xs: "16px", sm: "30px" },
            lineHeight: "120%",
            textAlign: "right",
            letterSpacing: "0.02rem",
            color: "#FFFFFF",
            zIndex: "0",
            paddingBottom: "5%",
          }}
        >
          {data.heading}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontStyle: "normal",
            fontWeight: "200",
            fontSize: { xs: "10px", sm: "20px" },
            lineHeight: "120%",
            textAlign: "right",
            letterSpacing: "0.02rem",
            color: "#FFFFFF",
            zIndex: "0",
            paddingBottom: "5%",
          }}
        >
          {data.content}
        </Typography>
        <Link
          to="/clientForm"
          style={{
            display: "flex",
            width: "150.84px",
            height: "52.23px",
            backgroundColor: "#F005A2",
            borderRadius: "45.25px",
            opacity: "100%",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 2% 0 2%",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <div
            style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: "18px",
              letterSpacing: "8%",
              fontWeight: "700",
            }}
          >
            Know More
          </div>
          <div
            className="submitBtn__Arrow"
            style={{
              width: "32.84px",
              height: "32.23px",
              backgroundColor: "#FFFFFF",
              borderRadius: "45.25px",
              opacity: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "7%",
            }}
          >
            <ArrowForwardIcon />
          </div>
        </Link>
      </Box>
    </Paper>) :
    <Paper
            sx={{
              background:
                "linear-gradient(90.92deg, #000000 0.5%, rgba(102, 102, 102, 0) 36.86%)",
              filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
              position: "relative",
              maxWidth: "100%",
              height: { xs: "300px", sm: "480px" },
              backgroundColor: "#7F0055",
              marginTop: { xs: "2%", sm: "3%" },
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            {/* Background Image */}
            <img
              src="/assets/AdvancedAI/transformBusiness.webp"
              alt="Transform"
              loading="lazy"
              style={{
                position: "absolute",
                top: "0",
                height: "100%",
                width: "auto",
                zIndex: "-1",
                filter: { xs: "brightness(40%)", sm: "none" }, // Dull the image on mobile
              }}
            />
            {/* Overlay for mobile background dullness */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.6)", // Dark overlay to dull the image
                zIndex: "-1",
                display: { xs: "block", sm: "none" }, // Display overlay only on mobile
              }}
            />
            <Box
              sx={{
                position: "absolute",
                left: { xs: "10%", sm: "24%" },
                top: { xs: "25%", sm: "30%" },
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                padding: { xs: "0 10%", sm: "0 5% 0 20%" },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Orbitron",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: { xs: "18px", sm: "30px" },
                  lineHeight: "120%",
                  textAlign: "right",
                  letterSpacing: "0.02rem",
                  color: "#FFFFFF",
                  zIndex: "0",
                  paddingBottom: "5%",
                }}
              >
                Transform your business and gain a competitive advantage through
                real-time monitoring, enhanced product delivery, and data-driven
                intelligence with Tecloq.
              </Typography>
              <Link
                to="/clientForm"
                style={{
                  display: "flex",
                  width: "150.84px",
                  height: "52.23px",
                  backgroundColor: "#F005A2",
                  borderRadius: "45.25px",
                  opacity: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 2% 0 2%",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: "18px",
                    letterSpacing: "8%",
                    fontWeight: "700",
                  }}
                >
                  Know More
                </div>
                <div
                  className="submitBtn__Arrow"
                  style={{
                    width: "32.84px",
                    height: "32.23px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "45.25px",
                    opacity: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "7%",
                  }}
                >
                  <ArrowForwardIcon />
                </div>
              </Link>
            </Box>
          </Paper>
    
  )
}

export default TransformComponent